import { TaxLoader } from './TaxLoader';

export const taxLoader: { (token?: string): TaxLoader } = (token) => new TaxLoader(token);
